import React from "react";
import * as Redux from 'react-redux';
import { Message } from 'semantic-ui-react';

import * as messageActions from './../actions/messageActions';
import * as pageActions from './../actions/pageActions';

export class Messages extends React.Component {
	componentDidMount() {
		var {dispatch, messages} = this.props;
		dispatch(messageActions.clear());
		if (messages.nextSuccesses.length > 0)
			dispatch(messageActions.showNext());
	}

	componentWillReceiveProps(nextProps) {
		var {dispatch, messages} = nextProps;
		
		if (messages.status === 404) {
			dispatch(pageActions.setRedirectTo("/notfound"));
		}
	}

	render() {
		var {messages} = this.props;
		
		return (
			<div className="ygl-message">
				{
					messages.info.length > 1 
						? <Message info header="Info" list={messages.info}></Message>
						: (messages.info.length === 1 
							? <Message info header="Info" content={messages.info[0]}></Message>
							: "")
				}
				{
					messages.successes.length > 1 
						? <Message success header="Successes" list={messages.successes}></Message>
						: (messages.successes.length === 1 
							? <Message success header="Success" content={messages.successes[0]}></Message>
							: "")
				}
				{
					messages.warnings.length > 1 
						? <Message color="yellow" header="Warnings" list={messages.warnings}></Message>
						: (messages.warnings.length === 1 
							? <Message color="yellow" header="Warning" content={messages.warnings[0]}></Message>
							: "")
				}
				{
					messages.errors.length > 1 
						? <Message error header="Errors" list={messages.errors}></Message>
						: (messages.errors.length === 1 
							? <Message error header="Error" content={messages.errors[0]}></Message>
							: "")
				}
			</div>
		);
	}
}

export default Redux.connect(
	(state) => {
		return state;
	}
)(Messages);


// WEBPACK FOOTER //
// ./src/components/Messages.js